var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_3425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_910_3425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: -12,
    width: 57,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 -11.25C79.3869 -11.25 86.7014 -9.79505 93.526 -6.96822C100.351 -4.14139 106.551 0.00195408 111.775 5.22525C116.998 10.4485 121.141 16.6495 123.968 23.4741C126.795 30.2986 128.25 37.6132 128.25 45C128.25 52.3869 126.795 59.7014 123.968 66.526C121.141 73.3505 116.998 79.5515 111.775 84.7748C106.551 89.9981 100.35 94.1414 93.5259 96.9682C86.7013 99.7951 79.3868 101.25 72 101.25L72 45V-11.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_910_3425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6597 48.5773C57.0597 48.9802 56.4958 49.4429 55.9772 49.9614L49.3652 56.5729C46.921 59.0168 46.093 62.6449 47.2349 65.9073L51.1974 77.2289C51.5537 78.2468 52.8513 78.5426 53.6135 77.7797L63.7563 67.6377L58.2058 50.4577C58.0049 49.8359 57.8229 49.2088 57.6597 48.5773Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7993 68.1933L90.3856 77.7795C91.1489 78.5429 92.4477 78.2465 92.8043 77.2275L96.7655 65.9099C97.9076 62.6466 97.0794 59.0175 94.6347 56.5728L88.0236 49.9617C87.6864 49.6245 87.3301 49.311 86.9571 49.0222C86.8256 49.5035 86.6829 49.9821 86.5293 50.4577L80.7993 68.1933Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0833 12.034C72.2467 11.8939 72.4877 11.8939 72.6511 12.034L76.6648 15.4743C83.9337 21.7048 88.1172 30.8006 88.1172 40.3744C88.1172 43.7974 87.5817 47.2004 86.5293 50.4577L78.8747 74.1483C78.751 74.5312 78.3945 74.7906 77.9922 74.7906H66.7422C66.3398 74.7906 65.9834 74.5312 65.8597 74.1483L58.2058 50.4577C57.1535 47.2004 56.6172 43.7974 56.6172 40.3744C56.6172 30.8006 60.8006 21.7048 68.0696 15.4743L72.0833 12.034Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4443 29.2284C71.253 28.1842 73.4814 28.1842 75.29 29.2284C77.0987 30.2726 78.2129 32.2025 78.2129 34.2909C78.2129 36.3794 77.0987 38.3092 75.29 39.3534C73.4814 40.3976 71.253 40.3976 69.4443 39.3534C67.6357 38.3092 66.5215 36.3794 66.5215 34.2909C66.5215 32.2025 67.6357 30.2726 69.4443 29.2284Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2058 50.4577L63.7563 67.6377L53.6135 77.7798C52.8513 78.5427 51.5537 78.2468 51.1974 77.2289L47.2349 65.9073C46.093 62.6449 46.921 59.0168 49.3652 56.5729L55.9772 49.9614C56.4958 49.4429 57.0597 48.9802 57.6597 48.5773C57.8229 49.2088 58.0049 49.8359 58.2058 50.4577ZM58.2058 50.4577L65.8597 74.1483C65.9834 74.5312 66.3398 74.7906 66.7422 74.7906H77.9922C78.3945 74.7906 78.751 74.5312 78.8747 74.1483L86.5293 50.4577M58.2058 50.4577C57.1535 47.2004 56.6172 43.7974 56.6172 40.3744C56.6172 30.8006 60.8006 21.7048 68.0696 15.4743L72.0833 12.034C72.2467 11.8939 72.4877 11.8939 72.6511 12.034L76.6648 15.4743C83.9337 21.7048 88.1172 30.8006 88.1172 40.3744C88.1172 43.7974 87.5817 47.2004 86.5293 50.4577M86.5293 50.4577C86.6829 49.9821 86.8256 49.5035 86.9571 49.0222C87.3301 49.311 87.6864 49.6245 88.0236 49.9617L94.6347 56.5728C97.0794 59.0175 97.9076 62.6466 96.7655 65.9099L92.8043 77.2275C92.4477 78.2465 91.1489 78.5429 90.3856 77.7795L80.7993 68.1933L86.5293 50.4577ZM66.5215 34.2909C66.5215 32.2025 67.6357 30.2726 69.4443 29.2284C71.253 28.1842 73.4814 28.1842 75.29 29.2284C77.0987 30.2726 78.2129 32.2025 78.2129 34.2909C78.2129 36.3794 77.0987 38.3092 75.29 39.3534C73.4814 40.3976 71.253 40.3976 69.4443 39.3534C67.6357 38.3092 66.5215 36.3794 66.5215 34.2909Z",
    stroke: "#007BFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 46.6666L72 136.667L40.5 46.6666M103.5 46.6666H40.5M103.5 46.6666V100.667H40.5V46.6666M45 73.6666L72 46.6666L99 73.6666M56.6169 25.2916L72.3669 11.7916L88.1169 25.2916M88.1247 46.5V25.125H56.6247V46.5M88.1247 46.5L72.3747 94.125L56.6247 46.5M88.1247 46.5V74.625H56.6247V46.5M72.3667 27.5408L78.2123 30.9158V37.6658L72.3667 41.0408L66.521 37.6658V30.9158L72.3667 27.5408Z",
    stroke: "#007BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_3425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.5d8f20e0dd2db37f251737febc90d265.svg";
export { ForwardRef as ReactComponent };